import React from 'react';

import PropTypes from 'prop-types';
import styled from 'styled-components';

import { COLORS } from 'apps/web_forms/utils/constants';

const sharedBadgeCss = `
  display: inline-block;
  min-width: 2em;
  padding: .3em;
  border-radius: 50%;
  font-size: 14px;
  text-align: center;
  background: ${COLORS.red};
  color: #fefefe;
  margin-left: .5em;
`;
const domBadgeCss = `${sharedBadgeCss}
  background: ${COLORS.red};
`;
const BadgeSpan = styled.span`
  ${sharedBadgeCss}
  background: ${(props) => (!props?.bgColor ? COLORS.red : props?.bgColor)};
`;

const Badge = ({ children, id, bgColor, className }) => (
  <BadgeSpan id={id} bgColor={bgColor} className={className}>
    {children}
  </BadgeSpan>
);

Badge.propTypes = {
  children: PropTypes.node.isRequired,
  id: PropTypes.string,
  className: PropTypes.string,
  bgColor: PropTypes.string,
};
Badge.defaultProps = {
  id: undefined,
  className: undefined,
  bgColor: COLORS.red,
};

const createBadgeElement = (number, id) => {
  const elem = document.createElement('span');
  elem.setAttribute('id', id);
  elem.style = domBadgeCss;
  elem.textContent = String(number);
  return elem;
};

export default Badge;
export { Badge, createBadgeElement };
